export const getNodeFromPath = (path: string): Node | null => {
    const domNode = document.getElementById(path)

    return domNode || null
}

export const hasParentWithId = (node: Node | null, id: string): boolean => {
    let currentNode: Node | null = node

    while (currentNode !== null) {
        if (currentNode instanceof Element && currentNode.id === id) {
            return true
        }
        currentNode = currentNode.parentNode
    }

    return false
}

export const getContainerElementId = (node: Node | null): string | null => {
    let currentNode: Node | null = node

    while (currentNode !== null) {
        if (currentNode instanceof Element && currentNode.id.includes('content-')) {
            return currentNode.id
        }
        currentNode = currentNode.parentNode
    }

    return null
}

export const splitSelectionIntoIndividualRanges = (selection: Selection) => {
    const ranges: Range[] = []

    if (selection.rangeCount === 0) {
        return ranges // No selection exists
    }

    // Get the full range of the selection
    const fullRange = selection.getRangeAt(0)
    const { startContainer, endContainer, startOffset, endOffset } = fullRange

    // Handle case where selection starts and ends in the same element
    if (startContainer === endContainer) {
        ranges.push(fullRange)
        return ranges
    }

    // Create a range starting from the anchor (start) node
    let currentNode = startContainer
    const currentRange = document.createRange()
    currentRange.setStart(startContainer, startOffset)
    currentRange.setEnd(startContainer, startContainer.textContent?.length ?? 0)
    ranges.push(currentRange)

    // Move to the next sibling node and create a range for each element until we reach the end node
    while (currentNode && currentNode !== endContainer) {
        currentNode = currentNode.nextSibling as Node

        if (currentNode && currentNode.nodeType === Node.TEXT_NODE) {
            const range = document.createRange()
            range.selectNodeContents(currentNode)
            ranges.push(range)
        }
    }

    // Create the final range within the end node
    const endRange = document.createRange()
    endRange.setStart(endContainer, 0)
    endRange.setEnd(endContainer, endOffset)
    ranges.push(endRange)

    return ranges
}
